import { AddressBookTag, TagTypeEnum } from '../../../generated';
import { getSortedAddressBookTags } from './getSortedAddressBookTags';

export const getOtherAddressBookTags = (addressBookTags?: AddressBookTag[]) => {
  return getSortedAddressBookTags(
    addressBookTags?.filter((x) => x?.tag?.tagTypeEnum === TagTypeEnum.Specialties && !x.isPrimary),
  );
};
